/**
 * GENERATED by scripts/gen-theme.mjs from the sidecar's GET /api/design — do not edit by hand.
 *
 * CommonJS because tailwind.config.js reads it; the .d.ts beside it is what src/useLayout.ts reads.
 * Everything here is a token the design system owns: the six type steps in px, the radius ladder
 * derived from one --radius, the two layout breakpoints, and the colour roles pointed at the CSS
 * variables in global.css.
 */
module.exports = {
  "accentHue": 304,
  "theme": "default",
  "fontFamily": {
    "display": [
      "Space Grotesk",
      "Segoe UI",
      "system-ui",
      "-apple-system",
      "sans-serif"
    ],
    "mono": [
      "JetBrains Mono",
      "Consolas",
      "ui-monospace",
      "monospace"
    ],
    "sans": [
      "Inter",
      "Segoe UI",
      "system-ui",
      "-apple-system",
      "sans-serif"
    ],
    "serif": [
      "Iowan Old Style",
      "Palatino Linotype",
      "Georgia",
      "serif"
    ]
  },
  "fontSize": {
    "display": [
      "34px",
      {
        "lineHeight": "40px",
        "letterSpacing": "-0.68px",
        "fontWeight": "600"
      }
    ],
    "title": [
      "24px",
      {
        "lineHeight": "30px",
        "letterSpacing": "-0.36px",
        "fontWeight": "600"
      }
    ],
    "heading": [
      "18px",
      {
        "lineHeight": "25px",
        "letterSpacing": "-0.18px",
        "fontWeight": "600"
      }
    ],
    "body": [
      "15px",
      {
        "lineHeight": "22px",
        "letterSpacing": "0px",
        "fontWeight": "400"
      }
    ],
    "small": [
      "13px",
      {
        "lineHeight": "19px",
        "letterSpacing": "0px",
        "fontWeight": "400"
      }
    ],
    "caption": [
      "11.5px",
      {
        "lineHeight": "16px",
        "letterSpacing": "0.632px",
        "fontWeight": "600"
      }
    ]
  },
  "borderRadius": {
    "sm": "8px",
    "md": "10px",
    "lg": "12px",
    "xl": "16px"
  },
  "screens": {
    "wide": "900px",
    "expanded": "1200px"
  },
  "breakpoints": {
    "wide": 900,
    "expanded": 1200
  },
  "colors": {
    "background": "hsl(var(--background))",
    "foreground": "hsl(var(--foreground))",
    "card": {
      "DEFAULT": "hsl(var(--card))",
      "foreground": "hsl(var(--card-foreground))"
    },
    "popover": {
      "DEFAULT": "hsl(var(--popover))",
      "foreground": "hsl(var(--popover-foreground))"
    },
    "primary": {
      "DEFAULT": "hsl(var(--primary))",
      "foreground": "hsl(var(--primary-foreground))"
    },
    "secondary": {
      "DEFAULT": "hsl(var(--secondary))",
      "foreground": "hsl(var(--secondary-foreground))"
    },
    "muted": {
      "DEFAULT": "hsl(var(--muted))",
      "foreground": "hsl(var(--muted-foreground))"
    },
    "accent": {
      "DEFAULT": "hsl(var(--accent))",
      "foreground": "hsl(var(--accent-foreground))"
    },
    "destructive": {
      "DEFAULT": "hsl(var(--destructive))",
      "foreground": "hsl(var(--destructive-foreground))"
    },
    "border": "hsl(var(--border))",
    "input": "hsl(var(--input))",
    "ring": "hsl(var(--ring))",
    "success": "hsl(var(--success))",
    "warning": "hsl(var(--warning))",
    "gradient-from": "hsl(var(--gradient-from))",
    "gradient-to": "hsl(var(--gradient-to))"
  }
};
